import { render } from "./channelRegister.vue?vue&type=template&id=4f38213c&scoped=true"
import script from "./channelRegister.vue?vue&type=script&lang=js"
export * from "./channelRegister.vue?vue&type=script&lang=js"

import "./channelRegister.vue?vue&type=style&index=0&id=4f38213c&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-case/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f38213c"]])

export default __exports__